// extracted by mini-css-extract-plugin
module.exports = {"btnRoot":"ButtonBackPage_btnRoot__2Wnxk","rotate":"ButtonBackPage_rotate__aN6Cz"};